import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";

const styles = createUseStyles(theme => ({
  settingsTab: {
    marginBottom: "30px"
  },
  details:{
    justifyContent: "space-between",
    margin: "32px 0 0"
  },
  title:{
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "28px",
    marginBottom: "4px",
    color: theme.tabs.titleColor,
  },
  description:{
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.tabs.descriptionColor,
  },
  dividerContainer:{
    display: "flex",
    alignItems: "center",
  },
  border:{
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin: "20px 0px"
  },
  personalDetails:{
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.tabs.containerTitleColor
  },
  leftContainer: {
    width: "304px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: 0
    }
  },
  rightContainer: {
    display: "grid",
    gap: "16px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: 0
    }
  },
  rightTopContainer: {
    display: "flex",
    gap: "8px",
    justifyContent: "space-between",
    alignItems:"center",
    width: "512px",
    borderRadius: "8px",
    border: "1px solid" + colors.lightGrey,
    padding: "16px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "auto",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
      flexDirection: "column",
      alignItems: "flex-start",
      margin: 0
    }
  },
  rightTopContainerWrapper:{
    display: "flex",
    gap: "16px",
    alignItems: "center",
    marginBottom: "20px",
    "&:last-child": {
      marginBottom: "0px",
    },
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  cardIcon: {
    overflow: "visible !important",
    "& svg": {
      width: "58px",
      height: "auto",
    }
  },
  cardDetails: {
    display: "flex",
    flexDirection: "column",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    overflow: "hidden !important",
    "& h1": {
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "20px",
      color: theme.tabs.containerTitleColor,
      margin: 0
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      color: theme.tabs.containerDescriptionColor,
      margin: 0
    }
  },
  cardNumberText: {
    color: colors.lightBlack
  },
  iconWrapper: {
    border: "1px solid" + colors.lightGrey,
    borderRadius: "10px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    height: "48px",
    width: "48px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    padding: "12px"
  },
  changeBtn: {
    padding: "10px 16px",
    height: "fit-content",
    "& :focus-visible": {
      boxShadow: "0px 0px 0px 4px " + colors.lightBlue
    },
    "& span": {
      whiteSpace: "nowrap"
    }
  },
  containerDescription: {
    "& h1": {
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "20px",
      color: theme.tabs.containerTitleColor,
      margin: 0
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      color: theme.tabs.containerDescriptionColor,
      margin: 0
    }
  },
  toggleContainer: {
    display: "flex",
    padding: "0 16px",
    alignItems: "flex-start"
  },
  container: {
    gap: "8px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "0 10px"
    }
  },
  redExpiredDate: {
    color: colors.error600
  },
  expiredDate: {
    color: colors.mediumGrey
  },
}));

export default styles;
